import {session} from 'wix-storage-frontend';
import wixLocationFrontend from 'wix-location-frontend';

// Get item popUpCloseBefore from session storage
const popUpClosedBefore = session.getItem('popUpClosedBefore');

// To know is page has been reloaded by compare previous url and current url
const previousUrl = session.getItem('previousUrl');
let currentUrl = wixLocationFrontend.url
let pageReloaded = currentUrl === previousUrl

$w.onReady(function () {

    // Clear all session storage if page reloaded
    if (pageReloaded) {
        session.clear();
    }
    // Delete popup if page reloaded and popup closed before
    else if (!pageReloaded && popUpClosedBefore == "true") {
        $w("#mobileBox1").delete();
    }

    // Respond only to the event of the close button in the popup
    // If close button is clicked, then delete popup from the page
    $w('#mobileButton3').onClick((event) => {
        $w("#mobileBox1").delete();
        session.setItem("popUpClosedBefore", "true");
    });
});

// Set item 'previousUrl'
session.setItem('previousUrl', currentUrl);